export default "__VITE_ASSET__c29ca09d__"